var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',_vm._g(_vm._b({staticClass:"sticky"},'v-footer',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }